import React from 'react';
import '../../styles/pages/about/AboutBanner.modules.scss'
import WorldGlobe from './WorldMap';
import myImg2 from '../../assets/images/myImg2.svg'
import Welcome3D from './Welcome3D';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function AboutBanner() {

  return (
    <>
    <div className="about-container">
        <div className="image-section world-map">
            < WorldGlobe className="worldm" />
        </div>
        <div className="content-section">
            <h1 className="graphical-name">Muntaza Kehase</h1>
            <img className="myImg" src={myImg2} />
        </div>
                        <Welcome3D height="10vh" rotate />

    </div>
    <div className="abstract-art-container">
      <div className="abstract-art">
        <div className="paint-drip"></div>
        <div className="paint-drip"></div>
        <div className="paint-drip"></div>
        <div className="paint-drip"></div>
        <div className="paint-drip"></div>
        <div className="paint-drip"></div>
      </div>
    </div>
</>
);
};

export default AboutBanner;
